module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_library.js
// module id = 170
// module chunks = 1